import { useState, useRef, useEffect, useMemo } from 'react';

import { SettingsItemId } from 'settings/Settings.types';

import { useDashboardItemsShapes } from 'settings/hooks/useDashboardItemsShapes';

import * as Styled from './SettingsDashboardItem.styled';

export function SettingsDashboardItemIcon({ id }) {
  const [hypothenuse, setHypothenuse] = useState<number>();
  const { icon, color } = useDashboardItemsShapes(id);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      const height = containerRef.current.clientHeight;
      setHypothenuse(Math.sqrt(height * height * 2));
    }
  }, [containerRef]);

  const containerStyle = useMemo(
    () => ({ height: hypothenuse }),
    [hypothenuse]
  );

  return (
    <div style={containerStyle}>
      <Styled.Icon backgroundColor={color} ref={containerRef}>
        {icon}
      </Styled.Icon>
    </div>
  );
}

export function SettingsDashboardItem({
  id,
  title,
  subtitle,
  className,
  onClick,
  link,
}: SettingsDashboardItemProps) {
  const isButton = link === undefined || !link;

  return (
    <Styled.AnchorContainer
      as={isButton ? 'button' : undefined}
      onClick={onClick}
      href={isButton ? undefined : link}
    >
      <Styled.ItemContainer
        hoverDepth={20}
        depth="moduleChrome"
        className={className}
      >
        <Styled.IconLabelContainer>
          <SettingsDashboardItemIcon id={id} />
          <Styled.Title>{title}</Styled.Title>
        </Styled.IconLabelContainer>

        <Styled.Subtitle>{subtitle}</Styled.Subtitle>
      </Styled.ItemContainer>
    </Styled.AnchorContainer>
  );
}

export interface SettingsDashboardItemProps {
  id: SettingsItemId;
  title: string;
  subtitle: string | null;
  link?: string;
  onClick?: () => void;
  className?: string;
}
